export const KUBEARCHIVE_PATH_PREFIX = 'plugins/kubearchive';
export const KUBEARCHIVE_RESOURCE_LIMIT = 30;
